<template>
    <div class="container-fluid bg-dark px-5 d-none d-lg-block">
        <div class="row gx-0 align-items-center" style="height: 45px;">
            <div class="col-lg-8 text-center text-lg-start mb-lg-0">
                <div class="d-flex flex-wrap">
                    <a href="#" class="text-light me-4">PMC EARR</a>
                    <a href="#" class="text-light me-4"><i
                            class="fas fa-phone-alt text-warning me-2"></i>+62811212365</a>
                    <a href="#" class="text-light me-0"><i
                            class="fas fa-envelope text-warning me-2"></i>cpmu.earr@gmail.com</a>
                </div>
            </div>
            <div class="col-lg-4 text-center text-lg-end">
                <div class="d-flex align-items-center justify-content-end">
                    <a href="#" class="btn nav-fill me-6 text-white">Bahasa / Language</a>
                    <a href="#" class="btn btn-light btn-square border rounded-circle nav-fill me-3"
                        :class="[((bahasa === null) || (bahasa == 'ina') ? 'btn-pmis' : '')]"
                        @click="gantibahasa('ina')"><img src="../../../../../src/assets/img/ina.jpg" height="20"></a>
                    <a href="#" class="btn btn-light btn-square border rounded-circle nav-fill me-3"
                        :class="[((bahasa == 'eng') ? 'btn-pmis' : '')]" @click="gantibahasa('eng')"><img
                            src="../../../../../src/assets/img/eng.jpg" height="20"></a>
                </div>
            </div>
        </div>
    </div>
    <!-- Topbar End -->
    <div class="container-fluid position-relative p-0">
        <nav class="navbar navbar-expand-lg navbar-light bg-white px-4 px-lg-5 py-3 py-lg-0">
            <a href="/" class="navbar-brand p-0">
                <h5 class="text-danger m-0 pmisdanger"><img src="../../../../../src/assets/img/berandaNgumahNew.png"
                        height="60"></h5>
                <!-- <img src="img/logo.png" alt="Logo"> -->
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <span class="fa fa-bars"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <div class="navbar-nav ms-auto py-0">
                    <a href="/"
                        :class="[((route.name == 'Beranda') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">BERANDA</span>
                        <span v-else>HOME</span>
                    </a>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'DaftarKonten')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            EARR
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/DaftarKonten/' + bytes1"
                                :class="[((route.name == 'DaftarKonten' && secretencData == '1') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">TENTANG EARR</span>
                                <span v-else>ABOUT EARR </span>
                            </a>
                            <a :href="'/DaftarKonten/' + bytes2"
                                :class="[((route.name == 'DaftarKonten' && secretencData == '2') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">UNIT KERJA / BALAI / PIU</span>
                                <span v-else>WORK UNIT</span>
                            </a>
                            <a :href="'/DaftarKonten/' + bytes3"
                                :class="[((route.name == 'DaftarKonten' && secretencData == '3') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">TIM PMC EARR</span>
                                <span v-else>EARR PMC TEAM</span>
                            </a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'DaftarKegiatan') || (route.name == 'DaftarProgramBudgeting')
                                || (route.name == 'DaftarFinance') || (route.name == 'DaftarMonev')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            MONITORING
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/DaftarKegiatan'"
                                :class="[((route.name == 'DaftarKegiatan') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">KEGIATAN UMUM</span>
                                <span v-else>GENERAL ACTIVITIES</span>
                            </a>
                            <a :href="'/DaftarProgramBudgeting'"
                                :class="[((route.name == 'DaftarProgramBudgeting') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRAM & BUDGETING</span>
                                <span v-else>PROGRAM & BUDGETING</span>
                            </a>
                            <a :href="'/DaftarFinance'"
                                :class="[((route.name == 'DaftarFinance') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">KEUANGAN</span>
                                <span v-else>FINANCE</span>
                            </a>
                            <a :href="'/DaftarMonev'"
                                :class="[((route.name == 'DaftarMonev') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">MONITORING DAN EVALUASI</span>
                                <span v-else>MONITORING AND EVALUATION</span>
                            </a>
                        </div>
                    </div>
                    <a :href="'/GIS/' + bytes"
                        :class="[((route.name == 'GIS') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">PETA</span>
                        <span v-else>MAPS</span>
                    </a>
                    <a href="/DaftarBerita"
                        :class="[((route.name == 'DaftarBerita') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">BERITA</span>
                        <span v-else>NEWS</span>
                    </a>
                    <a href="/DaftarAlbumDokumen"
                        :class="[((route.name == 'DaftarAlbumDokumen' || route.name == 'DaftarGaleriDokumen') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">DOKUMEN</span>
                        <span v-else>DOCUMENTS</span>
                    </a>
                    <a href="/DaftarAlbum"
                        :class="[((route.name == 'DaftarAlbum' || route.name == 'DaftarGaleri') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">GALERI</span>
                        <span v-else>GALLERY</span>
                    </a>
                    <a href="/KontakKami"
                        :class="[((route.name == 'KontakKami') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')"> KONTAK KAMI</span>
                        <span v-else>CONTACT US</span>
                    </a>
                    <a href="/Login"
                        :class="[((route.name == 'Login') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        LOGIN
                    </a>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        swal
    },
    data() {
        return {
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            bytes: encodeURIComponent(CryptoJS.AES.encrypt('Kosong', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes1: encodeURIComponent(CryptoJS.AES.encrypt('1', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes2: encodeURIComponent(CryptoJS.AES.encrypt('2', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes3: encodeURIComponent(CryptoJS.AES.encrypt('3', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),

            secretencData: '',
        };
    },
    methods: {
        gantibahasa(bahasanya) {
            localStorage.setItem("bahasasistem", bahasanya);
            location.reload();
        },
    },
    mounted() {
        try {
            this.secretencData = decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8));
        } catch (error) {
        }
    },
}
</script>

<style></style>